import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const CustomDoughnut = ({ label, data, period }) => {
    const organiques = data[1][period];
    const ads = data[2][period];
    const metas = data[3] ? data[3][period] : 0;
    const totalCorrect = organiques + ads + metas;
    
    const rawData = [
        { label: "Organiques", value: organiques, color: "#3B61E1" },
        { label: "Ads", value: ads, color: "#E7A85A" },
        { label: "Métas", value: metas, color: "#F4709F" }
    ];
    
    const filteredData = rawData.filter(item => item.value > 0);
    
    const chartData = {
        labels: filteredData.map(item => item.label),
        datasets: [
            {
                data: filteredData.map(item => item.value),
                backgroundColor: filteredData.map(item => item.color),
                borderWidth: 0,
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                display: true,
                align: "center",
                color: "#fff",
                font: {
                    size: 14,
                    weight: 600,
                },
                formatter: (value) => totalCorrect > 0 ? Math.round((value / totalCorrect) * 100) + "%" : "0%",
            },
        },
        cutout: 70,
    };

    return (
        <div className="custom-doughnut-container">
            {label && <span className="doughnut-title">{label}</span>}
            <Doughnut data={chartData} width={100} options={options} />
        </div>
    );
};

export default CustomDoughnut;
